import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.quotationTransporter.title, 'Transporter'),
  transporterName: () => __(translations.quotationTransporter.transporterName, 'Name'),
  transporterPrice: () => __(translations.quotationTransporter.transporterPrice, 'Price'),
  changesCommited: () => __(translations.quotationTransporter.changesCommited, 'Your changes has been saved successfully!'),
};
